import { Form, Formik } from 'formik';
import React from 'react';

import DropdownField from '@components/Form/DropdownField';
import useEventTracking from '@hooks/useEventTracking';
import { ClickTarget, click } from '@tracking';
import { SortOption } from '@utils/backend-api/search';

interface DropdownOption {
  label: string;
  value: SortOption;
}

const SORT_OPTIONS: DropdownOption[] = [
  { label: 'Most relevant', value: SortOption.Relevant },
  { label: 'Most recent', value: SortOption.Recent },
];

interface SortDropdownProps {
  onSortChange: (sort: SortOption) => void;
  sortDefault?: SortOption;
}

const SortDropdown = ({ sortDefault, onSortChange }: SortDropdownProps) => {
  const { trackEvent } = useEventTracking();
  const defaultSort = sortDefault ?? SortOption.Recent;
  const initialSort = SORT_OPTIONS.find((option) => option.value === defaultSort);

  const handleSubmit = (values: { sort: DropdownOption }) => {
    trackEvent(
      click({
        clickTarget: ClickTarget.SortDropdown,
        clickText: values.sort.label,
      })
    );

    const newSort = values.sort.value;
    onSortChange(newSort);
  };

  return (
    <Formik
      initialValues={{
        sort: initialSort,
      }}
      onSubmit={handleSubmit}
    >
      {({ setFieldValue, submitForm }) => (
        <Form data-id="sort-form" className="w-full sm:w-[258px]">
          <DropdownField
            className="flex items-center gap-12"
            label="Sort by"
            labelClassName="!text-black !font-suisse-intl !text-body-lg !m-0"
            name="sort"
            options={SORT_OPTIONS}
            placeholder="Sort by"
            onChange={(selectedOption: DropdownOption) => {
              setFieldValue('sort', selectedOption);
              submitForm();
            }}
          />
        </Form>
      )}
    </Formik>
  );
};

export default SortDropdown;
